export enum ActionType {
  Edit = 'edit',
  New = 'new',
  Show = 'show',
}
